import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'replaceIfNull',
  standalone: false,
})
export class ReplaceIfNull implements PipeTransform {
  transform(value: any) {
    if (value === null || value === undefined) {
      return '-';
    }

    return value;
  }
}
